import React, { useState } from "react";
import { Modal, Form, Input, InputNumber, Select } from "antd";
import axiosInstance from "../../network/axiosInstance";
import { notify, serverError } from "../../utils/notify";

const AddConfig = ({ visible, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await axiosInstance.post("/config", values);

      notify.success("Config added");

      form.resetFields();
      onSubmit();

      onClose();
    } catch (error) {
      if (error?.errorFields) return; // antd inline validation already shown
      console.error("Submit error:", error);
      notify.error(serverError(error, "Failed to add config"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Create New Config"
      open={visible}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      okText="Submit"
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Please enter office title" }]}
        >
          <Input placeholder="e.g. Lahore-office-1" />
        </Form.Item>

        <Form.Item
          name="pictureFrequency"
          label="Picture Frequency (seconds)"
          rules={[{ required: true, message: "Enter picture frequency" }]}
        >
          <InputNumber min={1} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="uploadFrequency"
          label="Upload Frequency (seconds)"
          rules={[{ required: true, message: "Enter upload frequency" }]}
        >
          <InputNumber min={1} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="wifi"
          label="WiFi Info (SSID,Password)"
          rules={[{ required: true, message: "Enter WiFi credentials" }]}
        >
          <Input placeholder="e.g. TTPL,MKTG1234" />
        </Form.Item>

        <Form.Item
          name="resolution"
          label="Resolution (width,height)"
          rules={[{ required: true, message: "Enter resolution" }]}
        >
          <Input placeholder="e.g. 1920,1080" />
        </Form.Item>

        <Form.Item
          name="rotation"
          label="Rotation"
          initialValue="0"
          rules={[{ required: true, message: "Please select rotation" }]}
        >
          <Select
            style={{ width: "100%" }}
            options={[
              { value: "0", label: "0" },
              { value: "90", label: "90" },
              { value: "180", label: "180" },
              { value: "270", label: "270" },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddConfig;
